import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../../../services/invoice.service';
import { CustomersService } from '../../../services/customers.service';
import moment from 'moment';

@Component({
  selector: 'app-erp-postedsalesorder',
  templateUrl: './erp-postedsalesorder.component.html',
  styleUrls: ['./erp-postedsalesorder.component.scss'],
  providers: [CustomersService]
})
export class ErpPostedsalesorderComponent implements OnInit {

  constructor(private invoiceService: InvoiceService, private _customersservice: CustomersService,) { }
  salesInvoices = [];
  salesOrdersConst = [];
  allowedPageSizes = [5, 10, 20];
  displayMode = 'full';
  showPageSizeSelector = true;
  showInfo = true;
  showNavButtons = true;
  selectedRows = [];
  loads = [];
  filteredCustomers: any = [];
  customerdata = []
  customerNameIdMap = {}
  salesOrderSearch = {
    customer: "",
    customerId: "",
    invoiceNo: "",
    fromDate: "",
    toDate: "",
  };
  ngOnInit(): void {
    this.getCustomerdata();
    this.getData();
  }
  getData() {
    this.invoiceService.getBCSalesInvoiceList().subscribe((data) => {
      this.salesInvoices = [];
      let orders = data && data.result.length > 0 ? data.result.reverse() : [];
      for (let order of orders) {
        let salesOrder = {
          customer: order.CustomerName,
          customerId: order.CustomerId,
          invoiceNo: order.InvoiceNo,
          postingDate: order.PostingDate,
          salesLines: []
        };

        for (let line of order.SalesLines) {
          salesOrder.salesLines.push({
            itemNo: line.ItemNo,
            description: line.Description,
            amount: line.LineAmount,
            unitPrice: line.UnitPrice,
            quantity: line.Quantity,
            loadNumber: line.Load ? Number(line.Load) : ""
          });
        }

        this.salesInvoices.push(salesOrder);
        this.salesOrdersConst.push(salesOrder);
      }

    });
  }
  getCustomerdata() {
    this.customerdata = [];
    this._customersservice.getCustomersData().subscribe((data) => {
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].name != undefined) {
          this.customerdata.push(data.result[i]);
          console.log(this.customerdata);
          this.customerNameIdMap[data.result[i].name] = data.result[i]._id;
          console.log(this.customerNameIdMap);
        }
      }
    });
    this.filteredCustomers = this.customerdata;
  }
  onCustomerChange(value) {
    if (value != "") {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      this.filteredCustomers = this.customerdata.filter((option) =>
        option.name.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
    } else {
      this.filteredCustomers = this.customerdata;
    }
  }
  // regular,
  // cancelled

  onCustomerSelected(customerName) {
    if (customerName != "") {
      this.salesOrderSearch.customer = customerName;
      this.salesOrderSearch.customerId = this.customerNameIdMap[customerName];
      console.log(this.salesOrderSearch.customer);
    }
  }
  onSearch() {
    console.log(this.salesOrderSearch);
    console.log(this.salesOrdersConst);
    this.salesInvoices = this.salesOrdersConst;
    for (const [key, value] of Object.entries(this.salesOrderSearch)) {
      if (key != "fromDate" && key != "toDate" && value) {
        this.salesInvoices = this.salesOrdersConst.filter((option) => {
          console.log("key", key, "value", value);
          if (JSON.stringify(option[key] ? option[key] : "") == JSON.stringify(value)) {
            return option;
          }
        });
      } else if (key == "fromDate" && value) {
        this.salesInvoices = this.salesOrdersConst.filter((option) => {
          if (moment(option["postingDate"]) >= moment(value)) {
            return option;
          }
        });
      } else if (key == "toDate" && value) {
        const currentMonth = moment().format("YYYY-MM");
        this.salesInvoices = this.salesOrdersConst.filter((option) => {
          if (moment(option["postingDate"]) <= moment(value)) {
            return option;
          }
        });
      }
    }
  }
  onReset() {
    this.salesOrderSearch = {
      customerId: "",
      customer: "",
      invoiceNo: "",
      fromDate: "",
      toDate: "",
    };
    this.salesInvoices = this.salesOrdersConst;
    this.filteredCustomers = this.customerdata;
  }

}
